// extracted by mini-css-extract-plugin
export default {"infoChats":"InfoChats_infoChats__JtpN+","infoItem":"InfoChats_infoItem__ocxPj"};